export default __webpack_public_path__ + "imgs/960f117ec043ff0bc443c46def103123.png";